import React from "react";

export const ExampleText = [
    {
        text: 'A Prayer For The Dead',
    },
    {
        text: 'Darood on Prophet Muhammad',
    },
    {
        text: 'Heavenly Father',
    },
    {
        text: 'Kel Maleh Rachamim',
    },
    {
        text: 'Lord Of All We Praise You',
    },
    {
        text: 'May their memory be a blessing',
    },
    {
        text: 'Meditation',
    },
    {
        text: 'Merciful Father And Lord Of All Life',
    },
    {
        text: 'Psalm 121',
    },
    {
        text: 'Surah Al-Fatihah',
    },
    {
        text: 'The Mourner’s Kaddish',
    }
]

export const marks = [
    {
        value: 0,
        label: '0',
    },
    {
        value: 100,
        label: '100',
    },
];

export const pixabayKey = "42318937-f344440143291fa01edfc5881";

export const categories = [
    'Social Announcements',
    'Funeral Programs',
    'Prayer Cards',
    'Traditional',
    'Shaped Designs',
    'Special Shapes',
    'Photo Enlargement',
    'Memorial fan',
    'Bookmarks',
    'Casket panel',
    'Memorial magnets',
    'Memorial blanket',
    'Thank you cards',
    'Let us design',
    'Pets',
    'Others'
];